export default "__VITE_ASSET__DJysnA7p__"